<template>
<div>
    <!-- <p class="tasks">Completed Tasks: {{todos.filter(todo => {return todo.done === true}).length}}</p>
    <p class="tasks">Pending Tasks: {{todos.filter(todo => {return todo.done === false}).length}}</p> -->
    <data-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="data in dataList" :data="data" v-bind:key="data.key" class="column is-half box" v-bind:class="isActive(data.status)"></data-view>
</div>
</template>

<style scoped>
.box{
    border: 1px solid #ccc;
    width: 49% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>
<script>
import DataView from './DataView';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            input: {
            },
            data : {
                repeatOn : []
            },
            result: "",
        };
    },
    props: ['dataList'],
    components: {
        DataView,
    },
    methods: {
        isActive(myStatus){
            if (myStatus == 1){
                return "active"
            }else{
                return ""
            }
        },
        deleteData(data) {
            let self = this;
            
            this.$swal({
                title: "Are you sure?",
                text: "This badge (" + data.title + ") will be PERMANENTLY REMOVED. To continue, enter 'REMOVE BADGE' in the text field below and press OK.",
                input: 'text',
                showCancelButton: true,
                inputValidator: (value) => {
                    if (value == "REMOVE BADGE"){
                        
                        this.input.email = localStorage.getItem('email')
                        this.input.dataID = data._id

                        const dataIndex = this.dataList.indexOf(data);
                        this.dataList.splice(dataIndex, 1);

                        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                        axios.defaults.responseType = 'json'
                        axios.post(process.env.MY_URL + '/api/badges/remove', this.input)
                            .then(response => {

                                if (response.data.success == false) {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    })
                                } else {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-success',
                                        duration: 3000
                                    })
                                }
                            })
                            .catch(e => {
                                console.log(e.response)
                                if (e.response.status === 401) {
                                    console.log("salah login")
                                    Toast.open({
                                        message: "Unauthorized access. Please re-login.",
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 10000
                                    })
                                } else {
                                    Toast.open({
                                        message: e,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 10000
                                    })
                                }
                            })

                    }else{
                        Toast.open({
                            message: "You did not enter REMOVE BADGE, so the badge is not removed.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                    }
                    //return !value && 'You need to write something!'
                }
            });
        },

        updateData(data) {

            console.log("updateData")
            console.log(data)

            if (data.title.length < 1){
                Toast.open({
                    message: "Please enter the title for the badge",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            if (data.isReplaceImage == 1){
                try {                
                    if (data.newLogoID.length < 5){
                        Toast.open({
                            message: "Please select the new image for the badge",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }
                }catch (err){
                    console.log(err)
                    Toast.open({
                        message: "Please select the image for the badge",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }

            if (data.triggerType == 1){
                if (data.predefinedTrigger == ''){
                    Toast.open({
                        message: "Please select the predefined award from the drop down list list",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }else if (data.triggerType == 2){
                if (data.customTrigger.length < 1){
                    Toast.open({
                        message: "Please select at least one behavior from the drop down list",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
                if (data.customTrigger.length > 1){
                    Toast.open({
                        message: "Sorry, currently you can only select one behavior for a badge.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
                if (data.threshold < 1){
                    Toast.open({
                        message: "Please enter the threshold (the minimum number of points to achieve to receive the badge)",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;
                }
            }else{
                //shouldn't reach here actually
                Toast.open({
                    message: "Please select the trigger type",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            data.email = localStorage.getItem('email')

                // this.input.email = localStorage.getItem('email')
                // this.input._id = data._id
                // this.input.title = data.title
                // this.input.message = data.message
                // this.input.repeatOn = data.repeatOn
                // this.input.repeatTime = data.repeatTime
                // this.input.status = data.status
                // this.input.target = 1   //1 is for teacher app

                console.log("before post updateData")
                console.log(data)
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/api/badges/update', data)
                    .then(response => {
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                        }
                    })
                    .catch(e => {
                        console.log(e.response)
                        if (e.response.status === 401) {
                            console.log("salah login")
                            Toast.open({
                                message: "Unauthorized access. Please login again.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: e,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        }
                    })

           
        },
    },
};
</script>

<style scoped>
p.tasks {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Database/Badges/DataList.vue